import { getFragmentData, graphql } from "../gql";
import { useQuery } from "@apollo/client";
import { UserFragment } from "./UserFragment.ts";
import {
  OneOnOneLessonType,
  SpeakingLevel,
  UserActivityRangesInput,
  UserListSortDirection,
  UserListSortField,
} from "../gql/graphql.ts";

const GetALlUsersQuery = graphql(`
  query listAllUsers(
    $nextPageToken: String
    $limit: Int!
    $email: String
    $userId: String
    $search: String
    $offset: Int
    $prevPageToken: String
    $withSpeakingLevel: [SpeakingLevel]
    $hasOneOnOneActive: Boolean
    $oneOnOneLessonType: OneOnOneLessonType
    $hasGroupPlanActive: Boolean
    $groupUserGroupId: String
    $sortBy: UserListSortField
    $sortDirection: UserListSortDirection
    $activityRanges: UserActivityRangesInput
  ) {
    listAllUsers(
      nextPageToken: $nextPageToken
      limit: $limit
      email: $email
      userId: $userId
      search: $search
      offset: $offset
      prevPageToken: $prevPageToken
      withSpeakingLevel: $withSpeakingLevel
      hasOneOnOneActive: $hasOneOnOneActive
      oneOnOneLessonType: $oneOnOneLessonType
      hasGroupPlanActive: $hasGroupPlanActive
      groupUserGroupId: $groupUserGroupId
      sortBy: $sortBy
      sortDirection: $sortDirection
      activityRanges: $activityRanges
    ) {
      users {
        ...UserFragment
      }
      hasNextPage
      nextPageToken
      hasPrevPage
      prevPageToken
      totalCount
    }
  }
`);
export function useAllUsers({
  nextPageToken,
  prevPageToken,
  limit,
  email,
  userId,
  search,
  offset,
  skip,
  withSpeakingLevel,
  hasOneOnOneActive,
  oneOnOneLessonType,
  hasGroupPlanActive,
  groupUserGroupId,
  sortBy,
  sortDirection,
  activityRanges,
}: {
  limit: number;
  nextPageToken?: string;
  prevPageToken?: string;
  email?: string;
  userId?: string;
  search?: string;
  offset?: number;
  skip?: boolean;
  withSpeakingLevel?: SpeakingLevel[];
  hasOneOnOneActive?: boolean;
  oneOnOneLessonType?: OneOnOneLessonType;
  hasGroupPlanActive?: boolean;
  groupUserGroupId?: string;
  sortBy?: UserListSortField;
  sortDirection?: UserListSortDirection;
  activityRanges?: UserActivityRangesInput;
}) {
  const { data, loading } = useQuery(GetALlUsersQuery, {
    variables: {
      limit,
      nextPageToken,
      email,
      userId,
      search,
      offset,
      prevPageToken,
      withSpeakingLevel,
      hasOneOnOneActive,
      oneOnOneLessonType,
      hasGroupPlanActive,
      groupUserGroupId,
      sortBy,
      sortDirection,
      activityRanges,
    },
    skip,
    fetchPolicy: "cache-and-network",
  });

  return {
    users: getFragmentData(UserFragment, data?.listAllUsers?.users ?? []),
    hasNextPage: data?.listAllUsers?.hasNextPage ?? false,
    nextPageToken: data?.listAllUsers?.nextPageToken,
    hasPrevPage: data?.listAllUsers?.hasPrevPage ?? false,
    prevPageToken: data?.listAllUsers?.prevPageToken,
    totalCount: data?.listAllUsers?.totalCount ?? 0,
    loading,
  };
}
